import { useTranslation } from '@sortlist-frontend/translation/ssr';

import { homeConfig } from '_features/home/home.config';

export const StatsSection = () => {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  return (
    <section className="py-20 bg-secondary-950">
      <div className="container-lg px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">
              {t('home:sections.stats.agencies.number')}
            </div>
            <div className="text-secondary-400 text-sm uppercase tracking-wider">
              {t('home:sections.stats.agencies.label')}
            </div>
          </div>
          <div>
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">
              {t('home:sections.stats.visitors.number')}
            </div>
            <div className="text-secondary-400 text-sm uppercase tracking-wider">
              {t('home:sections.stats.visitors.label')}
            </div>
          </div>
          <div>
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">
              {t('home:sections.stats.meetings.number')}
            </div>
            <div className="text-secondary-400 text-sm uppercase tracking-wider">
              {t('home:sections.stats.meetings.label')}
            </div>
          </div>
          <div>
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">
              {t('home:sections.stats.countries.number')}
            </div>
            <div className="text-secondary-400 text-sm uppercase tracking-wider">
              {t('home:sections.stats.countries.label')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
